document.addEventListener("DOMContentLoaded", () => {
  try {
    const scrollContainer = document.querySelector(
      ".collection-split .collection-split__products .float-grid"
    );
    const scrollbar = document.querySelector(".custom-scrollbar");
    const style = window.getComputedStyle(scrollContainer);
    const paddingLeft = parseInt(style.paddingLeft);
    const updateScrollbar = () => {
      const scrollWidth =
        scrollContainer.scrollWidth - paddingLeft - paddingLeft;
      const clientWidth =
        scrollContainer.clientWidth - paddingLeft - paddingLeft;
      const scrollLeft = scrollContainer.scrollLeft;

      const trackWidth = (clientWidth / scrollWidth) * clientWidth;
      const position = (scrollLeft / scrollWidth) * clientWidth;

      if (scrollWidth > clientWidth) {
        scrollbar.style.setProperty("--track-width", `${trackWidth}px`);
        scrollbar.style.setProperty("--position", `${position}px`);
        scrollbar.style.display = "block";
      } else {
        scrollbar.style.display = "none";
        scrollbar.style.setProperty("--track-width", `0px`);
      }
    };

    updateScrollbar();

    scrollContainer.addEventListener("scroll", updateScrollbar);

    window.addEventListener("resize", updateScrollbar);

    // set pc scroll
    const grid = document.querySelector(".collection-split__grid");
    const container = document.querySelector(
      ".collection-split__products .float-grid.grid--2"
    );
    const items = document.querySelectorAll(".collection-split__product");

    if (grid && container) {
      const gridHeight = grid.offsetHeight;

      container.style.maxHeight = `${gridHeight}px`;

      items.forEach((item) => {
        item.classList.remove("pc-hidden");
        item.style.display = "";
      });
    }
  } catch (e) {
    console.log(e);
  }
  // custom handle variant change
  window.customHandleVariantChange = function (variantData) {
    console.log(variantData, 'variantData')
    if(variantData) {
      toggleMedia(variantData.id);

      // Update inventory status
      // updateInventoryStatus(variantData);

      // quick-buy-modal update sku  add to cart text
      updateQuickBuyModalButtonText(variantData);

      setSizeDetail(variantData.option2)
    }

  }

  // quick-buy-modal update sku  add to cart text
  function updateQuickBuyModalButtonText(variantData) {
    const variantId = variantData.id;
    if (!variantId) return;
    const buttonEle = document.querySelector('.quick-buy-modal[data-type="updateSku"] .add-to-cart');
    const quickBuyVariantId = document.querySelector('.quick-buy-modal[data-type="updateSku"]')?.getAttribute('data-variant');
    if(buttonEle) {
      if(buttonEle.innerHTML === "Add to cart") {
        buttonEle.innerHTML = 'UPDATE';

        buttonEle.disabled = variantId === Number(quickBuyVariantId);
      }

    }
  }

  // Update inventory status based on variant id
  function updateInventoryStatus(variantData) {
    const variantId = variantData.id;
    if (!variantId) return;
    // 区分快速弹窗, 不影响详情页的
    const modal = document.querySelector('.quick-buy-modal[open]');
    const parentNode = modal ? modal : document;

    // Hide all status messages
    const allStatusMessages = parentNode.querySelectorAll('.product-block--inventory .inventory-status-p');
    allStatusMessages.forEach(msg => msg.style.display = 'none');
    // Show the status messages for the selected variant
    const variantMessage = parentNode.querySelector(`.product-block--inventory p[data-variant-id="${variantId}"]`);
    if(variantMessage) {
      variantMessage.style.display = 'block';
    }
  }

  // produc tvariant image
  function toggleMedia(variantId) {
    if(!variantId) return;
    // 区分快速弹窗不执行, 不影响详情页的
    const modal = document.querySelector('.quick-buy-modal[open]');
    if(modal) return;
    const mediaIds = document.querySelector(`[data-variant-id="${variantId}"]`).getAttribute('data-media-ids') || [];
    const productMediaIds = [];
    const productData = JSON.parse(document.querySelector('#product-data').getAttribute('data-product') || '[]');
    if(productData.media.length) {
      productData.media.map(function (i) {
        productMediaIds.push(String(i.id));
      })
    }
    // 判断productMediaIds和mediaIds有没有交集
    const hasIntersection = productMediaIds.some(id => mediaIds.includes(id));
    if(!hasIntersection) {
      document.querySelectorAll('.product-media-collage__item').forEach(function (i) {
        i.removeAttribute('hidden')
      })
      return;
    }
    if(mediaIds) {
      // pc
      document.querySelectorAll('.product-media-collage__item').forEach(function (i) {
        const mediaId = i.getAttribute('data-media-id');
        if(mediaIds.includes(mediaId)) {
          i.removeAttribute('hidden')
        }else{
          i.setAttribute('hidden', '')
        }
      })
      // mobile
      document.querySelectorAll('.mobile-only .slider__item').forEach(function (i) {
        const mediaId = i.getAttribute('data-media-id');
        if(mediaIds.includes(mediaId)) {
          i.removeAttribute('hidden')
        }else{
          i.setAttribute('hidden', '')
        }
      })
    }else{
      document.querySelectorAll('.product-media-collage__item').forEach(function (i) {
        i.removeAttribute('hidden')
      })
      document.querySelectorAll('.mobile-only .slider__item').forEach(function (i) {
        i.removeAttribute('hidden')
      })
    }
  }
  // product page init
  if(document.querySelector('#product-data')) {
    const firstVariantId = document.querySelector('#product-data').getAttribute('data-first-variant-id');
    // page load init
    toggleMedia(firstVariantId);
  }

  // product fit last tips
  function updateLastFilledSegment() {
    // Remove triangle class from all segments first
    document.querySelectorAll('.segment-bar__segment--filled').forEach(segment => {
      segment.classList.remove('segment-bar__segment--filled-last');
    });

    // Get all filled segments and add the class to the last one
    const filledSegments = document.querySelectorAll('.segment-bar__segment--filled');
    if (filledSegments.length > 0) {
      filledSegments[filledSegments.length - 1].classList.add('segment-bar__segment--filled-last');
    }
  }

  updateLastFilledSegment();

  function setSizeDetail(size) {
    const table = document.querySelector('.ks-table');
    if (!size || !table) return;


    const modal = document.querySelector('.quick-buy-modal[open]');
    if (modal) return;

    const rows = table.querySelectorAll('.ks-table-row');
    if (!rows.length) return;

    let sizeList = [];
    const sizeData = {};

    const firstRowCells = rows[0].querySelectorAll('.ks-table-cell');

    const isSizeInHeader = Array.from(firstRowCells).some(c => /^[A-Za-z0-9]{1,4}$/.test(c.textContent.trim()));

    const list = document.querySelectorAll('.ks-table');
    // 获取fr码dom
    let tailleEl = null;
    list.forEach(function (item){
      // fr码一定包含FR和TAILLE
      if(item.innerHTML.includes('FR') && item.innerHTML.includes('TAILLE')) {
        tailleEl = item;
      }
    });

    function parseTailleTable(tailleEl) {
      if (!tailleEl) return null;

      const rows = tailleEl.querySelectorAll('.ks-table-row');
      if (!rows.length) return null;

      const sizeData = {};

      // 表头
      const headerCells = rows[0].querySelectorAll('.ks-table-cell');
      const headers = Array.from(headerCells).slice(1).map(c =>
        c.textContent.trim()
      );

      // 数据行
      Array.from(rows).slice(1).forEach(row => {
        const cells = row.querySelectorAll('.ks-table-cell');
        if (!cells.length) return;

        const size = cells[0].textContent.trim();
        sizeData[size] = {};

        Array.from(cells).slice(1).forEach((cell, idx) => {
          const key = headers[idx];
          sizeData[size][key] = cell.textContent.trim();
        });
      });

      return sizeData;
    }

    if (isSizeInHeader) {
      // ================================
      // 尺码在列（你当前的情况）
      // ================================
      Array.from(firstRowCells).slice(1).forEach(c => {
        const s = c.textContent.trim();
        sizeList.push(s);
        sizeData[s] = {};
      });

      rows.forEach((row, i) => {
        if (i === 0) return;

        const cells = row.querySelectorAll('.ks-table-cell');
        const key = cells[0].textContent.trim();

        sizeList.forEach((s, idx) => {
          sizeData[s][key] = cells[idx + 1]?.textContent.trim() || '';
        });
      });
    } else {
      // ================================
      // 尺码在行（新需求）
      // ================================
      rows.forEach((row, i) => {
        const cells = row.querySelectorAll('.ks-table-cell');

        const first = cells[0].textContent.trim();

        if (i === 0) {
          // 表头（属性名）
          sizeList = Array.from(cells).slice(1).map(c => c.textContent.trim());
          return;
        }

        const s = first;
        sizeData[s] = {};
        Array.from(cells).slice(1).forEach((c, idx) => {
          const key = sizeList[idx] || `attr${idx}`;
          sizeData[s][key] = c.textContent.trim();
        });
      });
    }

    const data = sizeData[size];
    if (!data) return;
    const tailleTableData = parseTailleTable(tailleEl);
    const tailleFrData =  tailleTableData[size]?.['FR'];

    let html = Object.entries(data)
      .map(([key, value]) => `<div>${key}: <span>${value}</span></div>`)
      .join('');

    if(tailleFrData) {
      html = `<div>TAILLE (FR): <span>${tailleFrData}</span></div>` + html;
    }
    let existingNode = document.querySelector('#size-detail');
    if (!existingNode) {
      existingNode = document.createElement('div');
      existingNode.id = 'size-detail';
      existingNode.className = 'size-detail';

      const target = document.querySelector('.detail.product-column-right [option-target="option2"]');
      if (target) {
        target.insertAdjacentElement('afterend', existingNode);
      }
    }

    existingNode.innerHTML = html;
  }

  // 获取当前 option2（尺码）选中的值
  function getCurrentSize() {
    // 已选中的 swatch
    const activeSwatch = document.querySelector(
      '.detail.product-column-right [option-target="option2"] [aria-checked="true"], ' +
      '.detail.product-column-right [option-target="option2"] .is-active, ' +
      '.detail.product-column-right [option-target="option2"] .active'
    );
    if (activeSwatch) {
      return activeSwatch.getAttribute('data-value') ||
             activeSwatch.getAttribute('value') ||
             activeSwatch.textContent.trim();
    }
    // select 类型
    const select = document.querySelector('.detail.product-column-right [option-target="option2"] select');
    if (select) return select.value;
    return null;
  }

  // 初始化监听器
  function waitForTableAndInit() {
    const start = Date.now();

    const sizeDetailTimer = setInterval(() => {
      const table = document.querySelector('.ks-table');
      if (table) {
        const firstSize = JSON.parse(
          document.querySelector('#product-data')?.getAttribute('data-first-variant') || '{}'
        ).option2;

        setSizeDetail(firstSize);
        clearInterval(sizeDetailTimer);

        // 监听 .ks-table 内容变化（切换 cm/inches 时重新渲染 #size-detail）
        // debounce：切换单位时表格会批量更新多个单元格，合并成一次执行
        let debounceTimer = null;
        const tableObserver = new MutationObserver(() => {
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(() => {
            const currentSize = getCurrentSize();
            if (currentSize) {
              setSizeDetail(currentSize);
            }
          }, 100);
        });
        tableObserver.observe(table, { childList: true, subtree: true, characterData: true });
        return;
      }

      // 超过 30s 停止
      if (Date.now() - start >= 30000) {
        clearInterval(sizeDetailTimer);
      }
    }, 1000);
  }

  waitForTableAndInit();
  // build
  function waitForBundlesSave() {
    const observer = new MutationObserver(() => {
      const swatches = document.querySelector('.detail .swatches-type-products');
      if (swatches) {
        const colorList = document.querySelectorAll('[option-name="Colour"]') || [];

        colorList.forEach(option => {
          const items = option.querySelectorAll('li[orig-value]') || [];
          for (const li of items) {
            const origValue = li.getAttribute('orig-value');
            if (origValue && origValue.includes('/')) {
              // 创建 legend 元素
              const legend = document.createElement('p');
              legend.className = 'swatches-bundles-legend';
              legend.textContent = 'Bundles & Save:';

              // 插入到当前 li 之前
              li.parentNode.insertBefore(legend, li);
              break; // 找到第一个符合条件的就停止
            }
          }
        });

        observer.disconnect(); // 找到后停止监听
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
  waitForBundlesSave()
});

// nav hide tmenu_item_link
(function(){
  // Create a function to handle the elements
  const hideWatermarkElements = () => {
    document.querySelectorAll('.tmenu-watermark.tmenu_item_link').forEach(element => {
      element.style.display = 'none';
    });
  };

  // Create a MutationObserver instance
  const observer = new MutationObserver((mutations) => {
    hideWatermarkElements();
  });

  // Start observing the document with the configured parameters
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Initial check
  hideWatermarkElements();
})();

// 商品列表下拉加载更多
document.addEventListener('DOMContentLoaded', function() {
  const productGrid = document.getElementById('product-grid');
  if (!productGrid) return;

  // 获取当前页码和总页数
  let currentPage = parseInt(productGrid.dataset.currentPage) || 1;
  const totalPages = parseInt(productGrid.dataset.totalPages) || 1;

  // 如果只有一页，不需要加载更多功能
  if (totalPages <= 1) {
    const loadingMore = document.querySelector('.loading-more');
    if (loadingMore) {
      loadingMore.style.display = 'none';
    }
    return;
  }

  const loadingMore = document.querySelector('.loading-more');
  let isLoading = false;
  let hasMore = true;

  // 获取下一页URL
  function getNextPageUrl() {
    const url = new URL(window.location.href);
    url.searchParams.set('page', currentPage + 1);
    return url.toString();
  }

  // 加载更多商品
  async function loadMoreProducts() {
    if (isLoading || !hasMore) return;

    isLoading = true;
    loadingMore.classList.add('active');

    try {
      const response = await fetch(getNextPageUrl());
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const text = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');

      // 获取新的商品元素
      const newGrid = doc.getElementById('product-grid');
      if (newGrid && newGrid.children.length > 0) {
        // 将新商品添加到现有列表中
        Array.from(newGrid.children).forEach(child => {
          productGrid.appendChild(child.cloneNode(true));
        });

        currentPage++;

        // 检查是否还有更多页
        if (currentPage >= totalPages) {
          hasMore = false;
          loadingMore.innerHTML = '<div class="loading-more__text">--end--</div>';
        }
      } else {
        throw new Error('No products found');
      }
    } catch (error) {
      console.error('error:', error);
      hasMore = false; // 加载失败时停止后续加载
      loadingMore.innerHTML = '<div class="loading-more__text">Loading failed, please refresh to try again!</div>';
    } finally {
      isLoading = false;
      if (hasMore) {
        loadingMore.classList.remove('active');
      }
    }
  }

  // 监听滚动事件
  let scrollTimeout;
  window.addEventListener('scroll', function() {
    if (scrollTimeout) {
      clearTimeout(scrollTimeout);
    }

    scrollTimeout = setTimeout(function() {
      const productGridRect = productGrid.getBoundingClientRect();
      const scrollPosition = window.innerHeight - productGridRect.bottom;

      // 当商品容器底部距离视窗底部小于300px时触发加载
      if (scrollPosition > -300) {
        loadMoreProducts();
      }
    }, 100);
  });
});

/* toast */
(function () {
  let container = null;

  function createContainer() {
    container = document.createElement('div');
    container.className = 'toast-container';
    document.body.appendChild(container);
  }

  function show(message, duration = 3000) {
    if (!container) createContainer();

    if (container.children.length >= 2) {
      container.children[0].remove();
    }

    const toast = document.createElement('div');
    toast.className = 'toast';
    toast.textContent = message;
    container.appendChild(toast);

    void toast.offsetWidth;
    toast.classList.add('show');

    setTimeout(() => {
      toast.classList.remove('show');
      setTimeout(() => {
        toast.remove();
        if (container && container.children.length === 0) {
          container.remove();
          container = null;
        }
      }, 300);
    }, duration);
  }

  window.toast = show;
})();

// 监听加购商品，检查购物车中是否存在相同商品
(function() {
  // 获取购物车数据
  async function getCartData() {
    try {
      const response = await fetch('/cart.js');
      return await response.json();
    } catch (error) {
      console.error('Failed to fetch cart data:', error);
      throw error;
    }
  }

  // 加购提示重复加购
  document.addEventListener('on:cart:add', async (event) => {
    if (!event.detail || !event.detail.variantId) return;
    // 快速加购不提示
    const inQuickBuy = event.target.closest('.quick-buy-modal[open]');
    if(inQuickBuy) return;
    const variantId = parseInt(event.detail.variantId);

    try {
      // 延迟一点获取购物车数据，确保加购操作已完成
      setTimeout(async () => {
        // 获取购物车数据
        const cart = await getCartData();

        // 找到当前添加的商品
        const currentItem = cart.items.find(item => item.variant_id === variantId);

        if (!currentItem) return;

        // 获取表单中的数量输入
        const quantityInput = document.querySelector('form[action="/cart/add"] [name="quantity"]');
        const addedQuantity = quantityInput ? parseInt(quantityInput.value) : 1;

        // 如果购物车中的数量大于刚刚添加的数量，说明之前已经添加过
        if (currentItem.quantity > addedQuantity) {
          toast(`You've selected [${currentItem.product_title}] multiple times. Let’s check your cart together!`);
        }
      }, 100);
    } catch (error) {
      console.error('Error in cart add listener:', error);
    }
  });
})();

// pages/student-teacher-healthcare-worker-discount 样式修改
document.addEventListener("DOMContentLoaded", () => {
  try {
    if (!location.href.includes('student-teacher-healthcare-worker-discount')) return;

    const root = document.querySelector('#beans-id-root');
    const shadow = root?.shadowRoot;

    if (!shadow) return;

    // 插入样式
    const style = document.createElement('style');
    style.textContent = `
      * {
        color: #543c29 !important;
        font-family: Cardo, serif !important;
      }
    `;
    shadow.appendChild(style);

    // 图片资源
    const svgs = [
      'https://cdn.shopify.com/s/files/1/0686/6793/2851/files/student-1.png?v=1747471486',
      'https://cdn.shopify.com/s/files/1/0686/6793/2851/files/student-2.png?v=1747471486',
      'https://cdn.shopify.com/s/files/1/0686/6793/2851/files/student-3.png?v=1747471486',
    ];

    const handleInsert = () => {
      const pList = shadow.querySelectorAll('p.font-gibson-semibold.text-grey-500');
      pList.forEach((pEl, index) => {
        if (pEl.dataset.modified) return; // 防止重复处理
        pEl.dataset.modified = 'true';

        // 处理文本
        pEl.textContent = pEl.textContent.replace(/^\d+%\s*/, '');

        // 插入图片
        const svgIndex = index % svgs.length;
        const img = document.createElement('img');
        img.src = svgs[svgIndex];
        img.style.width = '36px';
        img.style.height = '36px';

        pEl.style.display = 'flex';
        pEl.style.alignItems = 'center';
        pEl.style.gap = '6px';

        pEl.insertBefore(img, pEl.firstChild);
      });
    };

    // 初始化处理一次
    handleInsert();

    // 设置 observer，监听 shadow DOM 中的变化
    const observer = new MutationObserver(() => {
      handleInsert();

      // 如果所有目标都已处理，断开 observer
      const unprocessed = shadow.querySelector('p.font-gibson-semibold.text-grey-500:not([data-modified])');
      if (!unprocessed) observer.disconnect();
    });

    observer.observe(shadow, { childList: true, subtree: true });

  } catch (e) {
    console.error(e);
  }
});

document.addEventListener("DOMContentLoaded", () => {
  try {
    // 获取 video 元素
    const video = document.querySelector('video.image-adv__media');
    if(video) {
      video.autoplay = true;
      video.play().catch(err => {
        console.log('播放失败:', err);
      });
    }
  } catch (e) {
    console.error(e);
  }

  try {
    const form = document.querySelector('.detail.product-column-right .form.js-product-form');
    const terms = document.querySelector('.detail.product-column-right shopify-payment-terms');

    if (form && terms) {
      form.appendChild(terms.cloneNode(true)); // true 表示深拷贝（包含子节点）
    }

  } catch (e) {
    console.error(e);
  }
});

